import { MessageCircle } from "lucide-react";
import { useSite, waLinkFor } from "@/lib/SiteContext";

export default function FloatingWhatsApp() {
  const { contact } = useSite();
  if (contact.floating_whatsapp === false) return null;

  return (
    <a
      data-testid="floating-whatsapp"
      href={waLinkFor(contact)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="group fixed bottom-6 right-6 z-[60] flex items-center gap-0 rounded-full bg-[#25D366] p-4 text-white shadow-xl shadow-[#25D366]/30 transition-all duration-300 hover:bg-[#1eb857] hover:gap-2"
    >
      <MessageCircle size={22} className="fill-white/20" />
      <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold transition-[max-width] duration-300 group-hover:max-w-[110px]">
        Contact us
      </span>
    </a>
  );
}
